import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formata número para moeda brasileira (R$ 1.234,56).
 *
 * Uso: {{ valor | brlCurrency }}          → R$ 1.234,56
 *      {{ valor | brlCurrency:false }}    → 1.234,56 (sem prefixo)
 *
 * Aceita number, string numérica ou null/undefined (retorna "R$ 0,00").
 */
@Pipe({ name: 'brlCurrency' })
export class BrlCurrencyPipe implements PipeTransform {

  transform(value: any, showPrefix: boolean = true): string {
    const num = this.parseNumber(value);
    const formatted = num.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return showPrefix ? `R$ ${formatted}` : formatted;
  }

  private parseNumber(value: any): number {
    if (value == null || value === '') return 0;
    const num = typeof value === 'string' ? parseFloat(value) : Number(value);
    return isNaN(num) ? 0 : num;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/brl-currency.pipe.ts